import { render, staticRenderFns } from "./AssignRoute.vue?vue&type=template&id=831eacaa&scoped=true&"
import script from "./AssignRoute.vue?vue&type=script&lang=js&"
export * from "./AssignRoute.vue?vue&type=script&lang=js&"
import style0 from "./AssignRoute.vue?vue&type=style&index=0&id=831eacaa&prod&scoped=true&lang=css&"
import style1 from "./AssignRoute.vue?vue&type=style&index=1&id=831eacaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831eacaa",
  null
  
)

export default component.exports